import { useMemo, useState, useEffect } from 'react';
import styled from 'styled-components';
import normalize from 'normalize-strings';
import { getUserLog } from '../../services/userService';
import DataTable from '../DataTable';
import getColumns from './columns';
import GridFilter from './GridFilter';
import ProfileTableExportFunctions from '../DataTable/TableExportFunctions/profileTableExportFunctions';

const TopPanel = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: ${({theme}) => theme.colors.bg_gray};
  align-items: center;
  padding: 8px;
  margin-bottom: 8px;

  @media screen and (min-width: 768px) {
    flex-direction: row;
  }
`;

function UserLog({userData}) {
  const [loading, setLoading] = useState(false);
  const [loadingError, setLoadingError] = useState(null);
  const [logData, setLogData] = useState([]);
  const columns = useMemo(getColumns, []);
  const [filtered, setFiltered] = useState(null);
  const [gridSearch, setGridSearch] = useState('');

  const gridData = useMemo(() => {
    if (logData) {
      const data = filtered || logData;
      return data;
    } else {
      return [];
    }
  }, [logData, filtered]);

  useEffect(() => {

    if(!loading && (gridSearch.trim().length > 0 )) {
      const regex = new RegExp(normalize(gridSearch), 'gi');
      let tempData = logData;

      setFiltered(tempData.filter(item => ((normalize(item.drone || '')).match(regex) || (normalize(item.incident || '')).match(regex) || (normalize(item.purpose || '')).match(regex))));
    } else {
      setFiltered(null);
    }

  }, [loading, gridSearch]);

  useEffect(() => {
    setLoading(true);
    setLoadingError(null);

    getUserLog()
      .then(data => setLogData(data))
      .catch(err => {
          setLoadingError('An error has occurred while loading user log data!');
      })
      .then(() => setLoading(false));
  }, []);

  return (
    <div id="UserLog">
      <h5 className="se-font-size-h-5">User Log</h5>
      <TopPanel>
        <GridFilter
          onSearchChange={value => setGridSearch(value)}
        />
        <ProfileTableExportFunctions
          tableData={logData}
          headers={columns}
          userData={userData}
        />
      </TopPanel>
      <DataTable
        columns={columns}
        data={gridData}
        loading={loading}
        error={loadingError}
        initialSortBy={{
            id: 'purpose',
            desc: true,
        }}
      />
    </div>
  );
}

export default UserLog;